<script>
import { stripePriceToString } from "/vodalys2023/stripe/stripe.utils.mjs";

import StripePrice from "/vodalys2023/stripe/main/components/StripePrice.vue";
import ProductCardPriceDiscount from './ProductCardPriceDiscount.vue';

export default {
  components: { StripePrice, ProductCardPriceDiscount },
  methods: {},
  props: {
    component: Object,
    handler: Object,
    chosen: Boolean,
    register: Boolean,
    registerUrl: String,
    doNotShowExpired: Boolean,
  },
  data: function () {
    return {
      cancelSubscriptionModalOpened: false,
      cancelSubscriptionModalPending: false,
      canceled: false,
    };
  },
  methods: {
    cancel: async function (action) {
      this.cancelSubscriptionModalPending = true;
      try {
        await this.handler.action(action, "cancel_subscription", []);
        this.canceled = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.cancelSubscriptionModalPending = false;
        this.cancelSubscriptionModalOpened = false;
      }
    },
  },
  computed: {
    hourPrice() {
      if (!this.component.additional_hour_stripe_price) {
        return this.component.meta.additionnal_hour;
      }
      return stripePriceToString(this.component.additional_hour_stripe_price);
    },

    metaLang() {
      if (/^fr/.test(this.$i18n.locale)) {
        return this.component.meta_fr
      }

      return this.component.meta;
    },
  },
};
</script>

<template>
  <div class="plan-tunnel-default" :class="{
    'most-popular': component.meta.most_popular,
    'current-plan': component.is_current_plan,
    chosen: chosen,
  }">
    <div class="plan-tunnel-default-title">{{ metaLang.title }}</div>
    <div class="plan-tunnel-default-cost" v-if="component.stripe_price">

      <ProductCardPriceDiscount :price="component.stripe_price"
        :discount-percentage="!component.expired && component.discount_percentage"
        :discount-tooltip="!component.expired && component.discount_tooltip" />
    </div>
    <div class="plan-tunnel-default-description">
      {{ metaLang.description }}
    </div>
    <div class="plan-tunnel-default-current-plan" v-if="component.is_current_plan && !component.expired">
      {{ $vt("Current plan") }}
    </div>
    <div class="plan-tunnel-default-expired-plan"
      v-if="component.is_current_plan && component.expired && !doNotShowExpired">
      {{ $vt("Expired") }}
    </div>
    <div class="plan-tunnel-default-line"></div>
    <div class="plan-tunnel-default-list">
      <div class="list-item" v-for="(list_item, index) in metaLang.list" :key="index">
        <div class="list-item-icon"><f-icon icon="fa6-check"></f-icon></div>
        <div>{{ list_item.text }}</div>
      </div>
    </div>
    <div class="plan-tunnel-default-expire_at" v-if="
      component.is_current_plan && component.expire_at && !component.expired
    ">
      {{ $vt("End of plan :") }}&nbsp;
      <MediumDate :timestamp="component.expire_at" />
    </div>
    <FButton v-if="component.cancel_subcription && !canceled" @click="cancelSubscriptionModalOpened = true"
      type="danger">
      {{ $vt("Cancel") }}
    </FButton>
    <FModalBase v-if="cancelSubscriptionModalOpened" closable backdrop-close
      @close="cancelSubscriptionModalOpened = false" :pending="cancelSubscriptionModalPending">
      <template #title2> {{ $vt("Cancel renew") }} </template>
      <template #content>
        <p style="max-width: 300px">
          {{ $vt("Your current plan will expire on") }}
          <MediumDate :timestamp="component.expire_at" />.
          {{ $vt("By clicking “CONFIRM”, you will still benefit of all features until this date.") }}
        </p>
      </template>
      <template #actions>
        <FButton type="secondary" @click="cancelSubscriptionModalOpened = false">
          {{ $vt("Cancel") }}
        </FButton>
        <FButton @click="cancel(component.cancel_subcription)" type="danger">{{ $vt("Confirm") }}
        </FButton>
      </template>
    </FModalBase>

    <div class="plan-tunnel-default-delete_at" v-if="
      component.is_current_plan && component.delete_at && component.expired && !doNotShowExpired
    ">
      <div>{{ $vt("All content deleted on :") }}</div>
      <div>
        {{ (component.delete_at * 1000) | angularFilter("MMMM, dd", "date") }}
      </div>
    </div>
    <f-button v-if="!component.is_current_plan && component.upgradable" type="primary"
      @click="$emit('upgrade', component)"><f-icon icon="fa6-circle-up"></f-icon>{{ $vt("Upgrade") }}</f-button>
    <f-button v-if="
      component.is_current_plan && !component.expired && component.extendable
    " type="primary" @click="$emit('upgrade', component)"><f-icon icon="fa6-plus"></f-icon>{{ $vt("Extend")
    }}</f-button>
    <f-button v-if="component.is_current_plan && component.expired" type="primary"
      @click="$emit('upgrade', component)"><f-icon icon="fa6-circle-up"></f-icon>{{ $vt("Renew") }}</f-button>
    <f-button v-if="register" type="primary" :href="registerUrl" blank><f-icon icon="fa6-circle-up"></f-icon>{{
      $vt("Register") }}</f-button>

    <div class="plan-tunnel-default-additionnal-hour" v-if="hourPrice">
      {{ $vt("Additional hour") }} {{ hourPrice }}

      <PlanTunnelHoursTooltip>
        <f-link><f-icon icon="fa6-circle-info"></f-icon></f-link>

      </PlanTunnelHoursTooltip>
    </div>
  </div>
</template>

<style lang="scss">
.plan-tunnel-default {
  width: 300px;
  background: var(--black);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 32px 48px 32px;
  border-radius: 12px;
  position: relative;
  box-shadow: 0px 24px 32px -8px rgba(22, 22, 21, 0.12);

  &.most-popular:after {
    content: "";
    width: 125px;
    height: 125px;
    position: absolute;
    top: -23px;
    right: -23px;
    background-image: url(popular.png);
  }

  &.current-plan {
    box-shadow: inset 0px 0px 0px 4px var(--navigation);
  }

  .plan-tunnel-default-title {
    text-align: center;
    font-family: Lato;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    /* 36px */
    color: var(--primary);
  }

  .plan-tunnel-default-cost {
    text-align: center;
    color: var(--white-a90);
    font-family: Lato;
    font-size: 60px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    /* 60px */
  }

  .plan-tunnel-default-description {
    color: var(--white-90, rgba(255, 255, 255, 0.9));
    text-align: center;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    /* 24px */
  }

  .plan-tunnel-default-current-plan,
  .plan-tunnel-default-expired-plan {
    align-self: center;
    display: flex;
    color: var(--white-a75);
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 8px 12px;
    background-color: var(--navigation);
    border-radius: 24px;
    text-transform: uppercase;
  }

  .plan-tunnel-default-expired-plan {
    background-color: var(--statusNegative);
  }

  .plan-tunnel-default-line {
    margin: 0 16px;
    height: 2px;
    border-radius: 1px;
    background: #373838;
  }

  .plan-tunnel-default-list {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .list-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--white-a75);
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%;
      /* 20px */

      .list-item-icon {
        color: var(--primary);
        font-weight: bold;
      }
    }
  }

  .plan-tunnel-default-expire_at {
    display: flex;
    justify-content: center;
    margin: 16px 0;
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
  }

  .plan-tunnel-default-delete_at {
    margin: 16px 0;
    color: var(--negative-a75);
    text-align: center;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
  }

  // .f-button {
  //   width: 100%;
  // }

  .plan-tunnel-default-additionnal-hour {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-self: center;
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
    /* 20px */
    margin-top: auto;

    align-items: baseline;
  }

  &.chosen {

    .plan-tunnel-default-current-plan,
    .f-button {
      display: none;
    }

    .plan-tunnel-default-line {
      margin-bottom: auto;
    }
  }
}
</style>